<template>
	<div id="systemContent">
		<div class="content mb20">
			<p>{{message.first.title}}</p>
			<div class="contentB"><img :src="message.first.img" style="width: 100%;" alt="" /></div>
		</div>
		<div class="content mb20">
			<p>{{message.second.title}}</p>
			<div class="contentB">
				<p>{{message.second.content}}</p>
			</div>
		</div>
		<div class="content mb20">
			<p>{{message.third.title}}</p>
			<div class="contentB">
				<p v-for='(item,index) in message.third.arr'>{{item}}</p>
			</div>
		</div>
		<div class="content mb20 shebei">
			<p>{{message.last.title}}</p>
			<div class="contentB">
				<div class="shebeiList" v-for="(item,index) in message.last.imgArr">
					<img :src="item.img" alt="" />
					<p>{{item.title}}</p>
				</div>
			</div>
		</div>
		<div class="content mb20" v-if='message.add'>
			<p>{{message.add.title}}</p>
			<div class="contentB">
				<p v-for='(item,index) in message.add.arr'>{{item}}</p>
			</div>
		</div>

	</div>

</template>

<script>
	export default {
		props: {
			activeIndex: {
				type: Number
			}
		},
		data() {
			return {
				message: {
					first: {
						title: '食品追溯系统示意图',
						img: 'http://img.anxuan360.com/FsQ9ToxKke5m9oiy49OlizdGE5mL'
					},
					second: {
						title: '详细介绍',
						content: '食品安全追溯系统在食品供应链中提供完全透明的管理能力，保障食品安全全程可视化控制、监控与追溯，可以全程监控食品生产、加工过程的添加剂以及有害物质、流通环节中的安全隐患。对有可能出现的食品安全隐患进行有效评估和科学预警提供依据。数据能够通过网络实现实时、准确报送，便于快速高效做更深层次的分析研究。消费者可查询所购买食品的完整追踪信息。'
					},
					third: {
						title: '服务亮点',
						arr: ['①、食品追溯系统帮助企业实现品牌价值的保护，让消费者对产品安全有据可循，同时满足企业管理诉求，面向中小企业信息化相对弱企业，通过平台的物流信息管理、流程管理帮助企业纸质电子化、痕迹管理。', '②、紧跟互联网+步伐，运用包装产品”一品一码”实现微信营销，打通多系统衔接，帮助企业实现产品营销。']
					},
					last: {
						title: '硬件设备',
						imgArr: [{
							title: '移动端设备',
							img: 'http://img.anxuan360.com/FsCHhOF3zZiuHO8GqvoZT9mkeOWc'
						}, {
							title: '电脑端设备',
							img: 'http://img.anxuan360.com/Fi6Sh_rd4-N8MPnQTJ6eNBvOjVjT'
						}, {
							title: '打印机',
							img: 'http://img.anxuan360.com/FizizZ2h9hWRaRfLsXw7SeCTGD3O'
						}]
					}
				},
				shebeiList: [{
						first: {
							title: '食品追溯系统示意图',
							img: 'http://img.anxuan360.com/FvL9-K88PhWZJEpCHvQfDTJQRxj-'
						},
						second: {
							title: '详细介绍',
							content: '食品安全追溯系统在食品供应链中提供完全透明的管理能力，保障食品安全全程可视化控制、监控与追溯，可以全程监控食品生产、加工过程的添加剂以及有害物质、流通环节中的安全隐患。对有可能出现的食品安全隐患进行有效评估和科学预警提供依据。数据能够通过网络实现实时、准确报送，便于快速高效做更深层次的分析研究。消费者可查询所购买食品的完整追踪信息。'
						},
						third: {
							title: '服务亮点',
							arr: ['①、食品追溯系统帮助企业实现品牌价值的保护，让消费者对产品安全有据可循，同时满足企业管理诉求，面向中小企业信息化相对弱企业，通过平台的物流信息管理、流程管理帮助企业纸质电子化、痕迹管理。', '②、紧跟互联网+步伐，运用包装产品”一品一码”实现微信营销，打通多系统衔接，帮助企业实现产品营销。']
						},
						last: {
							title: '硬件设备',
							imgArr: [{
								title: '追溯秤',
								img: 'http://img.anxuan360.com/FqVbBhdE9sXe_aRtLWzuIzPtzj3o'
							}, {
								title: '共享磅秤',
								img: 'http://img.anxuan360.com/Fo5CUvBvsgQ1Mu0jUWtg_dBSmjV4'
							}, {
								title: '查询机',
								img: 'http://img.anxuan360.com/FpuDSqFyG6vA5_u1d2BMeQJE3cyq'
							}, {
								title: '大屏',
								img: 'http://img.anxuan360.com/FohrPbv5rjfFAcXr4mBuD6wxMM-G'
							}]
						}
					},
					{
						first: {
							title: '食品检测系统示意图',
							img: 'http://img.anxuan360.com/Fpyl0xJ4cay8-N0SaRaohPhLjofP'
						},
						second: {
							title: '详细介绍',
							content: '食品检测系统基于物联网技术研发设计。食品检测数据将自动上传至监管平台，极大的提高了工作人员的效率，检测结果更加透明可信，对检测不合格产品实现自动预警，同时消费者可以通过公众监管平台查询检测数据。'
						},
						third: {
							title: '服务亮点',
							arr: ['通过智能化的操作平台和先进的光源驱动技术，对肉、鱼、蔬菜、水果、 茶叶、粮食、水及土壤中有害物质的快速检测，具有便捷的操作方式，优异的检测精度。方便用户简单、便捷、快速完成检测实验。强大组合查询功能，方便用户查询所需数据。智能显示检测流程， 并实时获取检测数据统计测试数据。软件配备有庞大的数据库，包含我司通过大量系统的实验所得的曲线库和通过查阅大量国家标准和行业标准总结而得的限值库等，在提高了检测准确性的同时使操作更加简化。']
						},
						last: {
							title: '硬件设备',
							imgArr: [{
								title: '食品测试仪',
								img: 'http://img.anxuan360.com/FsRVb25BHdT7exc-_oSRqOZkYXrf'
							}]
						},
						add: {
							title: '设备特点',
							arr: [
								'•  速度快：仪器内置恒温水浴槽及成品药剂，省去繁重培养仪器，提前测试速度。',
								'•  多用型食品分析，可以任意扩展食品安全检测项目，一机多用，是目前国内其它食品安全快速分析仪的替代产品。',
								'•  采用7.0寸以上高分辨率彩色液晶触摸屏全中文显示，界面直观，操作便捷。',
								'•  智能中文输入功能，可通过智能键盘和触摸笔直接输入中文，使检测记录更加详细直观。',
								'•  检测项目可扩展,每个项目实现8通道快速检测.',
								'•  带有嵌入式微型热敏打印机，直接打印每个检测通道的测试报告，报告详细直观，内容包含通道号、浓度、中文样品名、检测日期、检验员、检测单位。',
								'•  仪器采用光路自校正系统，实现开机自校，省略校0和100的步骤。',
								'•  仪器既可显示吸光值又能显示透光值，便于开展其它实验使用。',
								'•   自动显示样品中检测项目的浓度。',
								'•  仪器具有自动保存检测结果，并能随意查询保存的记录。',
								'•  带有RS232接口通讯功能，具有数据在线发送功能，可实现外部通讯和监控联网。'
							]
						}
					},
					{
						first: {
							title: '市场运营系统示意图',
							img: 'http://img.anxuan360.com/FklXWJHv1pSwediWHGEgWKCi9n5v'
						},
						second: {
							title: '详细介绍',
							content: '市场管理系统运用物联网技术，采集交易数据，通过“一云多端”智慧系统，实现农贸市场管理、服务和监管的信息网络化、工作规范化、管理现代化；系统利用先进的信息化手段，在实现关注食品安全，保护消费者权益、方便消费购物的同时，提升了市场管理水平，其具有针对性定制的功能模块，充分实现了信息的实时化、具体化、可视化，极大地方便了市场和相关职能部门对市场经营活动的动态监管。'
						},
						third: {
							title: '服务亮点',
							arr: ['对市场把握比较准，以市场为导向，面向经营和销售，对市场需求能准确包围，对市场的变化能迅速响应。且充分满足农产品从业者的所需所想，实现管理信息化、流程化、操作简单化、数据分析智能化、将管理思想融入到实际的运营中、全面满足农产品经营管理需求。']
						},
						last: {
							title: '硬件设备&软件系统',
							imgArr: [{
								title: 'ERP平台',
								img: 'http://img.anxuan360.com/FuaHn5hhtJKhvPjiYQ-7jkQsERNJ'
							}, {
								title: "安溯网",
								img: 'http://img.anxuan360.com/Fsnss4jq0g0Fj2f-endqK2Ih3uQy'
							}, {
								title: '大屏',
								img: 'http://img.anxuan360.com/FohrPbv5rjfFAcXr4mBuD6wxMM-G'
							}, {
								title: '追溯秤',
								img: 'http://img.anxuan360.com/FqVbBhdE9sXe_aRtLWzuIzPtzj3o'
							}]
						}
					},
					{
						first: {
							title: '商家管理系统示意图',
							img: 'http://img.anxuan360.com/FjcLR72RqXsF5vKkDChsjDIUqOE7'
						},
						second: {
							title: '详细介绍',
							content: '商家管理系统基于对仓库和财务的管理，实现通过对商品信息的管理及时更新，实现电子秤、网上菜场与后台之间的无缝链接，实现对商品，供应商，客户基本信息的管理，能够及时了解客户的消费状况；通过对财务的管理了解商品销售情况以及资金流通状况，合理利用资金。'
						},
						third: {
							title: '服务亮点',
							arr: ['实现商城商家商品管理、订单管理、促销管理、商铺管理、物流管理、售后管理、结算管理、统计分析和账号管理功能。这种模式把“生产商→经销商→消费者”各个产业链紧密连接在一起。整个供应链是一个从创造增值到价值变现的过程，把从生产、分销到终端零售的资源进行全面整合，不仅大大增强了电子商务的服务能力，更有利于客户获得附加价值的机会。']
						},
						last: {
							title: '硬件设备&软件系统',
							imgArr: [{
								title: 'ERP平台',
								img: 'http://img.anxuan360.com/FuaHn5hhtJKhvPjiYQ-7jkQsERNJ'
							}, {
								title: '安溯网',
								img: 'http://img.anxuan360.com/Fsnss4jq0g0Fj2f-endqK2Ih3uQy'
							}, {
								title: '云打印机',
								img: 'http://img.anxuan360.com/FsRVb25BHdT7exc-_oSRqOZkYXrf'
							}, {
								title: '智能小屏',
								img: 'http://img.anxuan360.com/FmXzeboI03FJxMK1GmFjhLmZWi6S'
							}, ]
						}
					},
					{
						first: {
							title: '会员营销系统示意图',
							img: 'http://img.anxuan360.com/FiuN8B2K7KSUE72QVj0sDVqYdwYX'
						},
						second: {
							title: '详细介绍',
							content: '会员营销系统包含会员管理系统、卡管理系统及商家营销管理三部分服务，是一个专门针对分布式多服务网点和单网点而设计的实时会员系统。会员卡管理系统集成了商户管理、会员管理、会员卡管理、会员积分管理、会员卡账管理、财务清算、会员制营销等功能于一体，商户可通过独立研发的读卡器、手持无线会员机、射频读卡器、条码扫描器等多种终端形式提供会员一卡通系统服务(会员卡、会员储值卡、会员积分卡、打折卡、体验卡等)。'
						},
						third: {
							title: '服务亮点',
							arr: ['除了丰富的会员营销和会员卡管理功能以外，还具有会员一卡通功能，提供了多种会员卡功能，如会员卡消费、会员卡充值、会员卡打折、会员卡积分、会员卡积分兑换、会员卡返利、会员卡密码修改、会员卡账管理、会员卡转账、会员卡查账等功能，真正体现了卖买提会员系统的一卡多用，一卡通用的特点。同时，企业可以通过会员卡系统对会员进行全方位的管理，企业可以随时了解门店、会员、会员卡的消费情况，帮助企业减轻终端管理难度，有效进行会员制营销。']
						},
						last: {
							title: '硬件设备',
							imgArr: [{
								title: '客流仪',
								img: 'http://img.anxuan360.com/FrOtC-VkJj-pVRFGw3p2o3buAt62'
							}, {
								title: '读卡器',
								img: 'http://img.anxuan360.com/FiLT6NM-XF-3JkvZxOM505x-FxyG'
							}, {
								title: '手持无线会员机',
								img: 'http://img.anxuan360.com/Fj5NXCjBzLwVvhdDMH763QFdXuKm'
							}, {
								title: '射频打卡器',
								img: 'http://img.anxuan360.com/Fmto-LSrPPnBiEQzkDLbzu30QLLb'
							}, {
								title: '条码扫描器',
								img: 'http://img.anxuan360.com/Flu9qB8tcnYLQPL63Ns2Zreqbe4p'
							}]
						}
					},
					{
						first: {
							title: '网上菜场系统示意图',
							img: 'http://img.anxuan360.com/Fu2frVNJ-ApDD7_NsHKfjOYwjgb3'
						},
						second: {
							title: '详细介绍',
							content: '网上菜场，是一个农贸市场互联网化的购菜平台，它所提供的商品是家庭里一日三餐所需要的相关菜蔬肉油等食品，并提供相应的免费配送服务，与一般老百姓走得更近。老百姓可以足不出户，在家轻点电脑键盘或者手机上即能购买到餐桌上的菜品，这一举措大大方便了上班早出晚归没时间上菜场的上班族或离菜场较远的居民们，解决了居民生活的后顾之忧，方便了那些上班早出晚归没时间上菜场的上班族或离菜场较远的居民们。'
						},
						third: {
							title: '服务亮点',
							arr: ['1、依靠互联网技术，运用大数据、移动互联、智能物联网、等技术及先进设备，实现人、货、场三者之间的最优化匹配', '2、紧跟互联网+步伐，帮各商家和市场一站式解决资金存管、支付、资金安全等问题', '3、让产品可追溯，依托现代互联网、物联网与大数据技术作支撑的农产品溯源系统，实现农产品在整个流通过程中信息可视化']
						},
						last: {
							title: '硬件设备',
							imgArr: [{
								title: '移动端设备',
								img: 'http://img.anxuan360.com/FsCHhOF3zZiuHO8GqvoZT9mkeOWc'
							}, {
								title: '电脑端设备',
								img: 'http://img.anxuan360.com/Fi6Sh_rd4-N8MPnQTJ6eNBvOjVjT'
							}, {
								title: '打印机',
								img: 'http://img.anxuan360.com/FizizZ2h9hWRaRfLsXw7SeCTGD3O'
							}]
						}
					},
					{
						first: {
							title: '市场招商系统示意图',
							img: 'http://img.anxuan360.com/FqEaoB8NYWqIfTTH8sM7r3OSJ8zz'
						},
						second: {
							title: '详细介绍',
							content: '市场招商系统是为农贸市场、农批市场、摊主提供一站式服务平台，服务包括：摊位转让、摊位租售、市场招租、求租摊位、求购摊位，并提供经营数据指导。不仅是智慧新农贸市场发布招商信息的一个平台,也是许多广告寻求市场合作的主要来源渠道。市场招商系统，通过后台系统发布招商、商户入驻等信息公告在市场内触摸显示屏和微信端。意向人群可在线提交入驻申请，再经由手机端将申请发送至市场管理人员账号中实时接收，实现新农贸市场智能招商，提供了一站式的服务。'
						},
						third: {
							title: '服务亮点',
							arr: ['1、智慧新农贸市场的精准管理，市场自身价值的裂变', '2、方便市场运营人员实时即使管理，满足当代农贸市场对智慧化管理的各项需求', '3、提供更加便捷的服务，商户们由于生意前期准备的东西比较多，时间上肯定是紧张的，所以如果农贸市场能够提供一些便捷的登记服务等等，会大量节省商户的时间']
						},
						last: {
							title: '硬件设备',
							imgArr: [{
								title: '显示屏',
								img: 'http://img.anxuan360.com/Fg5LJhVFijcVp-5d3Qa8--W1xuXn'
							}]
						}
					},
					{
						first: {
							title: '电子结算系统示意图',
							img: 'http://img.anxuan360.com/FpjnCYbUfUDNfBCtvI43S3wp0s75'
						},
						second: {
							title: '详细介绍',
							content: '电子结算系统是通过计算机系统和智能电子称相结合完成交易的信息化结算系统。电子结算系统改进了传统交易方式，通过电子结算系统实现交易电子化，市场交易无现金，提高市场的交易效率和管理质量，同时保证交易的公平公正。帮助农贸市场、网上农贸市场提供了一整套完整的资金管理解决方案，帮各商家和市场方一站式解决资金存管、支付、二清、税务、资金安全、监管合法等问题。'
						},
						third: {
							title: '服务亮点',
							arr: ['1、精准的互联网技术支撑，经营成本和处理成本的降低，在线商户的增加', '2、对农贸/农批市场转变，结合网上菜场系统，帮各商家和市场调节商品买卖，解决资金存管、支付、资金安全等问题', '3、能够进行实时结算，便利性强，适用范围广泛，支持小额结算，支持资金银行卡收单，支持网银自动转出，支付第三方平台支付（如微信/支付宝）等多种结算模式']
						},
						last: {
							title: '硬件设备',
							imgArr: [{
								title: '支付码牌',
								img: 'http://img.anxuan360.com/FuIj4OcDMeeayDfjUs7lfLOXjkOA'
							}, {
								title: "POS机",
								img: 'http://img.anxuan360.com/Fj5NXCjBzLwVvhdDMH763QFdXuKm'
							}, {
								title: '电脑端设备',
								img: 'http://img.anxuan360.com/Fi6Sh_rd4-N8MPnQTJ6eNBvOjVjT'
							}]
						}
					},
					{
						first: {
							title: '智能巡查系统示意图',
							img: 'http://img.anxuan360.com/FqvnHvT93z9cQBb3tE_0C7rTlchM'
						},
						second: {
							title: '详细介绍',
							content: '智能巡查系统是指通过物联网、人工智能、云计算、大数据等技术对传统的农贸市场进行升级改造，从而解决如食品溯源、短斤缺两等问题，充分实现了信息的实时化、具体化、可视化，极大地方便了市场和相关职能部门对市场经营活动的动态监管。使用智能巡查仪进行管理、拥有先进的设备，拥有信息发布手段，能够获取相关的数据。'
						},
						third: {
							title: '服务亮点',
							arr: ['1、解决了传统巡更管理方式中的一些关键问题，全面颠覆现有落后的巡更棒+单机管理软件的巡更管理模式，管理更加的智能化', '2、有效的控管及落实人员确实到位检查、保养以及检修矫正，并降低设备异常', '3、隐患及时分析和避免，出现问题的时候，智能巡检管理第一时间提示管理人员进行处理和调度，并且能够获取相关的数据进行处理']
						},
						last: {
							title: '硬件设备',
							imgArr: [{
								title: '智能巡查仪',
								img: 'http://img.anxuan360.com/FrXlzCLBOHUkIwTe1OQ81iWLYEmN'
							}]
						}
					},
					{
						first: {
							title: '数据展示系统示意图',
							img: 'http://img.anxuan360.com/FsKkADrUIELzO0M0Ux8wdNTjsaQW'
						},
						second: {
							title: '详细介绍',
							content: '数据展示系统是将 数据展现系统提供查询、报表、监控、预警、分析和挖掘等各种农贸市场和食品安全等相关的数据服务，以此为基础可以快速构建面向政府、农贸市场、商家和消费者等各层面的数据分析应用系统，给使用数据可视化系统的企业提供有效的指导参考以及多种实用的功能.'
						},
						third: {
							title: '服务亮点',
							arr: ['1、能够及时地将各种信息发布给市场相关的商户、涉农企业、农产品生产者、方便不同层次的用户了解市场信息', '2、具有跨平台支持，支持多种终端、安全可靠、结构灵活、简单易用', '3、可视化系统不仅仅是做到数据展示的美观，更重要的是可挖掘分析数据背后的价值和意义']
						},
						last: {
							title: '软件系统',
							imgArr: [{
								title: 'CRM系统',
								img: 'http://img.anxuan360.com/Fq2XzIrsFLhexPbDUVaX2D-Z-oDZ'
							}]
						}
					},
					{
						first: {
							title: '智慧农场系统展示图',
							img: 'http://img.anxuan360.com/FsJKb_93yrpGJSYCba3Kgah-4Aen'
						},
						second: {
							title: '详细介绍',
							content: '智慧农场系统是指将农业技术转化为信息和通信技术的新型物联网农场。随着科技的发达国家积极开发智能农业技术，新型的名为“智慧农场”的种植方式诞生了。智慧农场实现安装田间智能气象站设备、 视频设备、控制设备、信息系统等设备挖掘数据。利用互联网+云计算、数据挖掘进行多层分析，从而提高农业生产对生产中出现风险的应对能力，是弱势的传统农业成为具有高效的现代化产业有力的助手。智慧农场基于高科技的农业传感器进行实时监测、通过智能监控设备观察，农户可以通过智能手机或移动电脑在任何地方都可以进行耕作环境的远程监控和管理，提高农场生产效率，减少成本，提高农场建设管理水平，提高农产品生产及配送全过程的透明度，提高消费者参与度及满意度，为消费者提供安全/绿色/可追溯可视化的农产品服务'
						},
						third: {
							title: '服务亮点',
							arr: ['1.通过数十种农业智能传感设备及智能控制设备搭配农业生产监控网络，实现对气候环境，土壤状况，作物长势、病虫危害情况的实时监测，从而提高农品的产量', '2.实现农场现场各种农业设施设备进行远程自动化控制，有效的节省人力浪费，提高生产效率', '3.对于农场生产数据采集，智能化分析避免生产险情出现，杜绝因环境因素影响植物生长', '4.采用传递和交换方案，使产品具备质量跟踪追溯能力，确保产品质量安全。提高消费者参与度及满意度']
						},
						last: {
							title: '硬件设备',
							imgArr: [{
								title: 'CRM系统',
								img: 'http://img.anxuan360.com/Fq2XzIrsFLhexPbDUVaX2D-Z-oDZ'
							}, {
								title: '田间智能气象站',
								img: 'http://img.anxuan360.com/FmDnVtGgXgpPrCvlHoDIduJMFgbB'
							}, {
								title: '田间土壤传感器',
								img: 'http://img.anxuan360.com/Ft6vQFIHknRHw1a3zb-dZfJa6Q4X'
							}, {
								title: '田间农事记录仪',
								img: 'http://img.anxuan360.com/FrOtC-VkJj-pVRFGw3p2o3buAt62'
							}, ]
						}
					},
					{
						first: {
							title: '智慧禽畜系统展示图',
							img: 'http://img.anxuan360.com/FqDDDJO8URo9qljKlmU7FU3VTj58'
						},
						second: {
							title: '详细介绍',
							content: '智慧畜禽系统是基于移动无联网的信息化平台，利用通信技术把传感器、控制器、机器、人员和物等通过新的方式联在一起，形成人与物、物与物相联，连贯监控饲养管理、防疫、无害化处理、投入品管理、检疫申报、运输售卖等环节，帮助养殖场实现全过程动态化管理。不但能够加强生产管理，同时建立养殖产品供应链中原料、加工、包装、贮藏、销售等环节信息管理。实现各种生产数据的可追溯性，降低生产运营成本，规避风险，实现企业精细化管理'
						},
						third: {
							title: '服务亮点',
							arr: ['1.安全追溯-养殖过程可追溯，确保产品质量安全', '2.高效、经济、方便的养殖数据采集和控制技术', '3.助养殖企业节省人力成本，打破了数据孤岛，将数据利用到位，指导和推动生产结果']
						},
						last: {
							title: '硬件设备',
							imgArr: [{
								title: 'CRM系统',
								img: 'http://img.anxuan360.com/Fq2XzIrsFLhexPbDUVaX2D-Z-oDZ'
							}, {
								title: '电动喂料机',
								img: 'http://img.anxuan360.com/FiH8VqpFgugrg5Cm5DoaEXwmHkua'
							}, {
								title: '空气测试仪',
								img: 'http://img.anxuan360.com/FvU1Cbc_9sHvDW2RftUJoYaa4hSH'
							}, {
								title: '监视记录仪',
								img: 'http://img.anxuan360.com/FrOtC-VkJj-pVRFGw3p2o3buAt62'
							}, ]
						}
					},
					{
						first: {
							title: '智慧水产系统展示图',
							img: 'http://img.anxuan360.com/FuMlip2CLA4N6vfKecBi-VaJSC-8'
						},
						second: {
							title: '详细介绍',
							content: '智慧水产系统是一种通过智慧感测、智慧控制等新兴技术发展出的新型养殖方式。随着科技的发展，物联网养殖的出现，传统的养殖模式开始向这一新型养殖方式靠拢。物联网养殖采用无线传感技术、网络化管理等先进管理方法对养殖环境、水质、鱼类生长状况、药物使用、废水处理等进行全方位管理、监测，具有数据实时采集分析、食品溯源、生产基地远程监控等功能，以提升管理效率和生产力为标准，是现今全球的水产养殖业趋势。相比传统渔业，智慧渔业更加精细的生产规划、更精准的日常管理，快速应对各种环境状况，降低灾害风险；有效节省人力、产销成本及能源配置，在保证质量的基础上大大提高了产量'
						},
						third: {
							title: '服务亮点',
							arr: ['1.根据养殖预设条件自动控制换水、增氧、增温、喂料等设备的运行，满足严苛的水产养殖环境条件要求，减少不必要的损失，同时可以节省用电，降低生产成本', '2.养殖环境实时查看，远程实时监控，视频信息可回看、传输和存储，及时发现养殖过程碰到的问题，查找分析原因，解决所存在的问题，确保质量和产量', '3.监测养殖环境的水域，检测影响鱼类生长的各类信息参数，及时消除不利因素', '4.全方位管理养殖环境，数据能够实时采集分析、食品溯源、生产基地远程监控，在保证质量的基础上大大提高了产量']
						},
						last: {
							title: '硬件设备',
							imgArr: [{
								title: 'CRM系统',
								img: 'http://img.anxuan360.com/Fq2XzIrsFLhexPbDUVaX2D-Z-oDZ'
							}, {
								title: '水质检测器',
								img: 'http://img.anxuan360.com/FvDq4sOuw1Mv3FmqBnbZbgiynl3w'
							}, {
								title: '自动投饵机',
								img: 'http://img.anxuan360.com/FjbatxbSsP2wTXDHQxHW18Jqv2Ov'
							}, {
								title: '水产监视器',
								img: 'http://img.anxuan360.com/Fr0SN-OMtYPz2kjg-VLZa91LjeLS'
							}, ]
						}
					}
				],
			}
		},
		activated() {
			document.documentElement.style.fontSize = "";
		},
		mounted: function() {
			this.message = this.shebeiList[this.activeIndex]
		},
		methods: {
			navClick(data) {
				this.message = this.shebeiList[data]
			}

		},
		watch: {
			$route(to, from) {
				if(to.name == 'system') {
					this.message = this.shebeiList[to.query.activeIndex]
				}

			}
		},
		components: {

		}
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/system/systemContent1.vue